import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.songs');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-songs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.songs/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminSongsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public songs: any[] = [];
    public total: number = 0;
    public catalogTotal: number = 0;
    public approvedTotal: number = 0;
    public youtubeCandidateTotal: number = 0;
    public youtubeVerifiedTotal: number = 0;
    public youtubeMissingTotal: number = 0;
    public page: number = 1;
    public text: string = '';
    public curation_status: string = '';
    public youtube_match_status: string = '';
    public loading: boolean = false;
    public busyAction: string = '';
    public youtubeApiKey: string = '';
    public youtubeLimit: number = 10;
    public readonly csvColumns: string[] = [
        'title_ko', 'artist_name', 'release_year', 'primary_genre', 'male_female_profile',
        'low_note', 'high_note', 'comfortable_low', 'comfortable_high', 'chorus_peak_note',
        'difficulty_level', 'tj_song_no', 'ky_song_no', 'youtube_link', 'youtube_video_id',
        'thumbnail_url', 'curation_status'
    ];

    public editingSong: any = null;
    public showEditor: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("list", {
                page: this.page,
                dump: 20,
                text: this.text,
                curation_status: this.curation_status,
                youtube_match_status: this.youtube_match_status
            });
            if (code === 200) {
                this.songs = data.songs || [];
                this.total = data.total || 0;
                this.catalogTotal = data.catalog_total || 0;
                this.approvedTotal = data.approved_total || 0;
                this.youtubeCandidateTotal = data.youtube_candidate_total || 0;
                this.youtubeVerifiedTotal = data.youtube_verified_total || 0;
                this.youtubeMissingTotal = data.youtube_missing_total || 0;
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async search() { this.page = 1; await this.load(); }

    public hasFilters(): boolean {
        return !!(this.text || '').trim() || !!this.curation_status || !!this.youtube_match_status;
    }

    public async clearFilters() {
        this.text = '';
        this.curation_status = '';
        this.youtube_match_status = '';
        this.page = 1;
        await this.load();
    }

    public getEmptyTitle(): string {
        if (this.catalogTotal === 0) return '곡 데이터베이스가 비어 있습니다';
        if (this.hasFilters()) return '조건에 맞는 곡이 없습니다';
        return '등록된 곡이 없습니다';
    }

    public getEmptyDescription(): string {
        if (this.catalogTotal === 0) return '샘플 데이터를 추가하거나 CSV를 업로드해 곡 카탈로그를 시작하세요.';
        if (this.youtube_match_status === 'candidate') return 'YouTube 보강을 실행하면 후보 영상이 여기에 쌓입니다.';
        if (this.hasFilters()) return '검색어 또는 검수 상태 필터를 조정해보세요.';
        return '새 곡을 직접 등록하거나 CSV로 한 번에 업로드할 수 있습니다.';
    }

    public newSong() {
        this.editingSong = {
            title_ko: '', artist_name: '', release_year: 2024, primary_genre: 'ballad',
            male_female_profile: 'male', difficulty_level: 3, low_note: 0, high_note: 0,
            comfortable_low: 0, comfortable_high: 0, chorus_peak_note: 0,
            tj_song_no: '', ky_song_no: '', curation_status: 'pending',
            is_korean_song: true, rap_ratio: 0,
            youtube_link: '', youtube_video_id: '', thumbnail_url: '', youtube_match_status: ''
        };
        this.showEditor = true;
        this.service.render();
    }

    public async editSong(song: any) {
        let { code, data } = await wiz.call("get", { id: song.id });
        if (code === 200) { this.editingSong = data; this.showEditor = true; }
        await this.service.render();
    }

    public async saveSong() {
        if (this.busyAction) return;
        if (!this.editingSong.title_ko || !this.editingSong.artist_name) {
            await this.service.modal.error("곡명과 가수명은 필수입니다.");
            return;
        }
        this.busyAction = 'save';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("save", this.editingSong);
            if (code === 200) {
                this.showEditor = false;
                await this.service.modal.success("저장되었습니다.");
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "저장 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public async deleteSong(song: any) {
        if (this.busyAction) return;
        let res = await this.service.modal.show({
            title: '곡 삭제', message: `"${song.title_ko}"를 삭제하시겠습니까?`,
            action: '삭제', cancel: '취소', status: 'error', actionBtn: 'error'
        });
        if (!res) return;
        this.busyAction = 'delete:' + song.id;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("delete", { id: song.id });
            if (code === 200) {
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "삭제 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public cancelEdit() { this.showEditor = false; this.service.render(); }

    public downloadCSVTemplate() {
        const sample = [
            '사랑했지만', '김광석', '1995', 'ballad', 'male',
            '40', '62', '43', '59', '60', '3', '', '', '', '', '', 'pending'
        ];
        const csv = [this.csvColumns, sample]
            .map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(','))
            .join('\n');
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'voice-range-song-template.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    public async importCSV() {
        if (this.busyAction) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv';
        input.onchange = async () => {
            if (!input.files || input.files.length === 0) return;
            const fd = new FormData();
            fd.append('file', input.files[0]);
            this.busyAction = 'import';
            await this.service.render();
            try {
                let { code, data } = await wiz.call("import_csv", fd);
                if (code === 200) {
                    await this.service.modal.success(this.buildImportMessage(data, 'CSV 등록'));
                    await this.load();
                } else {
                    await this.service.modal.error(data?.message || "CSV 등록 실패");
                }
            } finally {
                this.busyAction = '';
                await this.service.render();
            }
        };
        input.click();
    }

    public async seedData() {
        if (this.busyAction) return;
        let res = await this.service.modal.show({
            title: '시드 데이터', message: '검수된 샘플 곡 데이터를 등록하시겠습니까? 이미 등록된 곡은 건너뜁니다.',
            action: '등록', cancel: '취소', status: 'warning', actionBtn: 'warning'
        });
        if (!res) return;
        this.busyAction = 'seed';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("seed");
            if (code === 200) {
                await this.service.modal.success(this.buildImportMessage(data, '샘플 데이터'));
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "샘플 데이터 등록 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public async enrichYouTube() {
        if (this.busyAction) return;
        const limit = Math.max(1, Math.min(Number(this.youtubeLimit || 10), 50));
        let res = await this.service.modal.show({
            title: 'YouTube 링크 보강',
            message: `YouTube 링크가 없는 곡 최대 ${limit}개를 공식 API로 검색합니다. 예상 quota는 최대 ${limit * 100} units입니다.`,
            action: '보강',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;

        this.busyAction = 'youtube';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("enrich_youtube", {
                api_key: this.youtubeApiKey,
                limit,
                curation_status: this.curation_status
            });
            if (code === 200) {
                await this.service.modal.success(this.buildYouTubeMessage(data));
                this.youtube_match_status = data?.updated > 0 ? 'candidate' : this.youtube_match_status;
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "YouTube 보강 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public getVisibleCandidateIds(): string[] {
        return this.songs
            .filter(song => song.youtube_match_status === 'candidate' && (song.youtube_video_id || song.youtube_link))
            .map(song => song.id);
    }

    public async reviewYoutube(song: any, action: string) {
        if (this.busyAction) return;
        const isVerify = action === 'verify';
        let res = await this.service.modal.show({
            title: isVerify ? 'YouTube 후보 승인' : 'YouTube 후보 반려',
            message: isVerify
                ? `"${song.title_ko}"의 YouTube 후보를 검수완료로 표시할까요?`
                : `"${song.title_ko}"의 YouTube 후보를 반려하고 링크를 비울까요?`,
            action: isVerify ? '승인' : '반려',
            cancel: '취소',
            status: isVerify ? 'warning' : 'error',
            actionBtn: isVerify ? 'warning' : 'error'
        });
        if (!res) return;

        this.busyAction = `youtube-review:${action}:${song.id}`;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("review_youtube", { id: song.id, action });
            if (code === 200) {
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "YouTube 검수 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public async verifyVisibleYoutubeCandidates() {
        if (this.busyAction) return;
        const ids = this.getVisibleCandidateIds();
        if (ids.length === 0) {
            await this.service.modal.error("현재 화면에 승인할 YouTube 후보가 없습니다.");
            return;
        }

        let res = await this.service.modal.show({
            title: 'YouTube 후보 일괄 승인',
            message: `현재 화면의 후보 ${ids.length}건을 검수완료로 표시할까요?`,
            action: '일괄 승인',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;

        this.busyAction = 'youtube-review-batch';
        await this.service.render();
        try {
            let { code, data } = await wiz.call("review_youtube_batch", { ids: ids.join(','), action: 'verify' });
            if (code === 200) {
                await this.service.modal.success(this.buildBatchReviewMessage(data));
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "YouTube 일괄 검수 실패");
            }
        } finally {
            this.busyAction = '';
            await this.service.render();
        }
    }

    public buildImportMessage(data: any, label: string): string {
        const count = data?.count || 0;
        const skipped = data?.skipped || 0;
        const errors = data?.errors || [];
        let message = `${label}: ${count}곡 등록`;
        if (skipped > 0) message += `, ${skipped}건 건너뜀`;
        if (errors.length > 0) message += `\n확인 필요: ${errors.join(' / ')}`;
        return message;
    }

    public buildYouTubeMessage(data: any): string {
        const updated = data?.updated || 0;
        const skipped = data?.skipped || 0;
        const apiCalls = data?.api_calls || 0;
        const quota = data?.quota_estimate || 0;
        const errors = data?.errors || [];
        let message = `YouTube 보강: ${updated}곡 업데이트, ${skipped}건 건너뜀`;
        message += `\nAPI 호출 ${apiCalls}회, 예상 quota ${quota} units`;
        if (errors.length > 0) message += `\n확인 필요: ${errors.join(' / ')}`;
        return message;
    }

    public buildBatchReviewMessage(data: any): string {
        const updated = data?.updated || 0;
        const skipped = data?.skipped || 0;
        const errors = data?.errors || [];
        let message = `YouTube 후보 검수: ${updated}건 완료`;
        if (skipped > 0) message += `, ${skipped}건 건너뜀`;
        if (errors.length > 0) message += `\n확인 필요: ${errors.join(' / ')}`;
        return message;
    }
}

export default PageAdminSongsComponent;